<div class="absolute left-72 right-8 top-32 bottom-8"
  [ngStyle]="{'left': 'calc(' + (screenWidth * 18 / 100) + 'px + 2rem)'}"
>
  <iframe class="h-full w-full rounded-lg border-2 border-cliking_blue" src="https://app.sociabble.com/Launch" frameborder="0"></iframe>
</div>